module.exports = __webpack_public_path__ + "img/ios-student.70fc085d.png";